import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';

const MarriageComponent = ({ formData, calculateMarriageImpact }) => {
  return (
    <Box>
      <Typography variant="h6">Marital Status</Typography>
      <Typography sx={{ mt: 1 }}>
        Your marital status influences your Comprehensive Ranking System (CRS) score because your partner's details (age, education, language skills, work experience) will be considered alongside yours.
      </Typography>

      {formData ? (
        <>
          {formData.maritalStatus && (
            <Typography sx={{ mt: 2 }}>
              {formData.maritalStatus === 'married'
                ? 'You are married.'
                : formData.maritalStatus === 'commonLaw'
                ? 'You are in a common-law relationship.'
                : 'You are single.'}
            </Typography>
          )}
          {formData.maritalStatus !== 'single' && calculateMarriageImpact && (
            <Typography sx={{ mt: 1 }}>
              Marriage impact on your CRS: {calculateMarriageImpact(formData.maritalStatus)}
            </Typography>
          )}
        </>
      ) : (
        <Typography sx={{ mt: 2 }}>
          Information about your marital status will be displayed here once available.
        </Typography>
      )}

        <Typography variant="subtitle1" sx={{ mt: 3, fontWeight: 'bold' }}>
        Examples of How Marriage Impacts Your CRS Score:
        </Typography>

        <List>
        <ListItem alignItems="flex-start">
            <ListItemText
            primary="Positive Impact:"
            secondary={
                <>
                <Typography variant="body2" component="span">
                    Your partner has strong credentials (higher education, excellent language proficiency, extensive work experience), increasing your overall CRS points.
                </Typography>
                <br />
                <Typography variant="body2" component="span">
                    <strong>Positive Impact Example:</strong> Suppose you're 32 years old with a Bachelor's degree and strong English skills. Your partner, who is 30, has a Master's degree, fluent English proficiency (IELTS 8), and five years of work experience. Your overall CRS score would likely increase compared to applying alone, since your partner brings additional points through higher education, language, and work experience.
                </Typography>
                </>
            }
            />
        </ListItem>
        <ListItem alignItems="flex-start">
            <ListItemText
            primary="Negative Impact:"
            secondary={
                <>
                <Typography variant="body2" component="span">
                    Your partner has limited credentials (lower language proficiency scores, minimal work experience), slightly lowering your combined CRS points compared to applying individually.
                </Typography>
                <br />
                <Typography variant="body2" component="span">
                    <strong>Negative Impact Example:</strong> If you have a high CRS score due to excellent language proficiency, advanced degrees, and extensive work experience, but your spouse or common-law partner has lower language scores, limited education, or little work experience, your combined CRS score could decrease slightly compared to applying individually.
                </Typography>
                </>
            }
            />
        </ListItem>
        </List>


      <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 'bold' }}>
        Quick Tips:
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Update all your partner's details accurately." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Consider improving weaker areas like language skills before applying." />
        </ListItem>
      </List>
    </Box>
  );
};

export default MarriageComponent;
